export default __webpack_public_path__ + "static/media/Gloves of the Blood Drinker (nm).3232ff54.jpg";